jQuery(document).ready(function($) {

	/**/
	var memorialGallery = $(".memorial-gallery");
	
	/* Memorial Images - BEGIN */
		var memorialImages = memorialGallery.find(".images .listing");

		memorialImages.addClass("owl-carousel").owlCarousel({
			items: 4,
			margin: app_margin,
			dots: false,
			loop: true,
			autoplay: false
		});

		memorialGallery.on('click', '#memorial-images-prev', function(event) {
			memorialImages.trigger('prev.owl.carousel');
		});

		memorialGallery.on('click', '#memorial-images-next', function(event) {
			memorialImages.trigger('next.owl.carousel');
		});
	/* Memorial Images - END */

	/* Memorial Videos - BEGIN */
		var memorialVideos = memorialGallery.find(".videos .listing");

		memorialVideos.addClass("owl-carousel").owlCarousel({
			items: 3,
			margin: app_margin,
			dots: false,
			loop: true,
			autoplay: false
		});

		memorialGallery.on('click', '#memorial-videos-prev', function(event) {
			memorialVideos.trigger('prev.owl.carousel');
		});

		memorialGallery.on('click', '#memorial-videos-next', function(event) {
			memorialVideos.trigger('next.owl.carousel');
		});

		memorialGallery.on('click', '.item', function(event) {
			var item       = $(this);
			var item_video = item.attr('data-video');
			var item_name  = item.attr('title');
			var modal      = $("#videoModal");

			modal.find('#videoModal-title').html(item_name);
			modal.find('#videoModal-iframe').attr('src', 'https://www.youtube.com/embed/'+item_video);
		});
	/* Memorial Videos - END */

});